import { mediaTypeList } from '../assets/constants';

export const checkPermissionTopic = (
    authorId: number,
    topicMembers: null | {
        email: string,
        userId: number,
        userName: string,
    }[],
    loginUserId: number
) => {
    if (topicMembers === null) return true;
    if (authorId === loginUserId) return true;
    if (topicMembers.some(member => member.userId === loginUserId)) return true;
    return false;
}

export const dateFormat = (date: string) => {
    const dateData = new Date(date);
    const month = zeroPadding(dateData.getMonth() + 1, 2);
    const day = zeroPadding(dateData.getDate(), 2);
    const year = dateData.getFullYear();
    const hours = zeroPadding(dateData.getHours(), 2);
    const minutes = zeroPadding(dateData.getMinutes(), 2);

    return `${year}/${month}/${day} ${hours}:${minutes}`;
}

export const getMediaTypeInfo = (name: string, info: "type" | "typeJa" | "color"): string => {
    const target = name.split('.').pop() as string;
    let result = "";
    mediaTypeList.forEach((mediaType) => {
        if (mediaType.extentions.includes(target)) {
            result = mediaType[info];
        }
    })
    return result;
}

export const isDateWithinOneWeek = (date: string) => {
    const dateData = new Date(date);
    const today = new Date(); // 現在の日付を取得
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7); // 7日前の日付をセット
    return dateData.getTime() > sevenDaysAgo.getTime();
}

// アップロードメディアのバリデーション
export const validateMedia = (file: File): { isValid: boolean, errorMessage?: string } => {
    const size = file?.size,
        type = file?.type;

    //拡張子
    if (
        type !== 'image/jpeg'
        && type !== 'image/gif'
        && type !== 'image/png'
        && type !== 'video/mp4'
    ) {
        return {
            isValid: false,
            errorMessage: '画像は、JPEG、PNG、GIFファイル、動画は、MP4ファイルのみ許可されています'
        }
    }
    //上限サイズ; 2GB
    if (size > 2 * 1024 * 1024 * 1024) {
        return {
            isValid: false,
            errorMessage: '選択されたファイルが2GBを超えています'
        }
    }
    return { isValid: true }
};

export const zeroPadding = (number: number, length: number) => {
    return (Array(length).join('0') + number).slice(-length);
}

export const fnSetIsEditorEmpty = (
    currentContentAsJSON: string,
    setIsEditorEmpty: React.Dispatch<React.SetStateAction<boolean>>,
) => {
    try {
        const nodeObj = JSON.parse(currentContentAsJSON);
        setIsEditorEmpty(
            (nodeObj.root.children.length === 1 && nodeObj.root.children[0].children.length === 0)
        );
    } catch (error) {
        console.log(error);
    }
};

export const extractTextFromJson = (contenAsJSON: string, charCount: number): string | undefined => {
    const regex: RegExp = /"text": "(.*?)"/g;
    const extractedTexts: string[] = [];

    let match: RegExpExecArray | null;
    while ((match = regex.exec(contenAsJSON)) !== null) {
        extractedTexts.push(match[1]);
    }

    const tempText = extractedTexts.join(" ")
    const formattedText = tempText.length > charCount
        ? tempText.slice(0, charCount) + "…"
        : tempText;
    return formattedText;
}

export const getCurrentDateTime = () => {
    const now = new Date();

    // 年、月、日、時、分を取得
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月は0から始まるため+1が必要
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');

    // "yyyy/MM/dd HH:mm"形式で文字列を組み立て
    return `${year}/${month}/${day} ${hours}:${minutes}`;
}

export const convertBytesToKB = (bytes: number) => {
    return (bytes / 1024).toFixed(2); // 2 decimal places
}

// 動画かどうかを判断
export const isVideo = (fileName: string): boolean => {
    const videoExtensions = ['mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv']; // 動画の拡張子リスト

    // ファイル名から拡張子を取得
    const fileExtension = fileName.split('.').pop()?.toLowerCase(); // TypeScript 3.7以降ではOptional Chainingが使えます

    // 動画の拡張子リストに含まれているかを確認
    return !!fileExtension && videoExtensions.includes(fileExtension);
};
